<template>
  <el-card header="新建">
    <el-form :model="ad"
             :rules="rules"
             ref="ruleForm"
             label-position="right"
             label-width="180px"
    >
      <el-form-item label="匹配的url地址" prop="match_url">
        <el-input v-model="ad.match_url">

        </el-input>
      </el-form-item>
      <el-form-item label="图片地址" prop="img_path">
        <!--<el-input v-model="ad.img_path"></el-input>-->
        <img-upload :return-url="true" v-model="ad.img_path"></img-upload>
      </el-form-item>
      <el-form-item label="广告位图片宽度" prop="img_w">
        <el-input-number v-model="ad.img_w"></el-input-number>
      </el-form-item>
      <el-form-item label="广告位图片高度" prop="img_h">
        <el-input-number v-model="ad.img_h"></el-input-number>
      </el-form-item>
      <el-form-item label="跳转地址" prop="href">
        <el-input v-model="ad.href">
          <template slot="prepend"></template>
        </el-input>
      </el-form-item>
      <el-form-item label="广告文字内容" prop="content">
        <el-input v-model="ad.content"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-input v-model="ad.type"></el-input>
      </el-form-item>
      <el-form-item label="位置" prop="position">
        <el-input v-model="ad.position"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="adCreate(ad)">创建</el-button>
        <el-button type="success" @click="backPage">返回</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
  import {mapState} from 'vuex'
  import back from '@/mixin/back'
  import ImgUpload from "../img/ImgUpload";

  export default {
    name: "AdCreate",
    mixins: [back],
    components: {ImgUpload},
    computed: {
      ...mapState({
        ad: state => state.ad.newAd,
        rules: state => state.ad.rules,
        loading: state => state.ad.loading,
      }),
    },
    methods: {
      adCreate(ad) {
        let vthis = this;
        this.$refs['ruleForm'].validate(validate => {
          if (!validate) {
            return;
          }
          this.$store.dispatch('ad/create', ad).then((res) => {
            vthis.$confirm('是否关闭此页面').then(_ => {
              vthis.$router.go(-1);
            }).catch(_ => {
            });
          })
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/ad/AdCreate.vue